import { render, staticRenderFns } from "./EmpresaListaCorreo.vue?vue&type=template&id=887b524e"
import script from "./EmpresaListaCorreo.vue?vue&type=script&lang=js"
export * from "./EmpresaListaCorreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports